import { createApi } from "@reduxjs/toolkit/query/react";
import { RootState } from "../../../reducers";
import { axiosBaseQuery } from "../../../axiosBaseQuery";

export const newSubscriptionsAmount = createApi({
  reducerPath: "newSubscriptionsAmount",
  baseQuery: (args, api) => {
    const state = api.getState() as RootState;

    const token = state.auth.access;

    let headers: Record<string, string> = {};
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    return axiosBaseQuery({
      baseUrl: process.env.REACT_APP_BASE_URL,
    })({ ...args, headers });
  },
  endpoints: (builder) => ({
    getNewSubscriptionsAmount: builder.query({
      query: ({
        startDate = null,
        endDate = null,
      }: {
        startDate?: Date | null | undefined | string;
        endDate?: Date | null | undefined | string;
      }) => ({
        url: `auth/chart_amount_new_subscriptions?start_date=${startDate}&end_date=${endDate}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetNewSubscriptionsAmountQuery } = newSubscriptionsAmount;
